export const menuItems = [
  {
    id: 1,
    label: "",
    isTitle: true,
  },
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 7,
    label: "menuitems.dashboard.text",
    icon: "bx-bar-chart-alt",
    link: "/",
    roleAdmin: true,
  },
  {
    id: 8,
    label: "menuitems.banner.text",
    icon: "bx-image",
    link: "/banner",
    roleAdmin: true,
  },
  // {
  //   id: 9,
  //   label: "menuitems.video.text",
  //   icon: "bx-video",
  //   link: "/video",
  //   roleAdmin: true,
  // },
  {
    id: 2,
    label: "menuitems.setting.text",
    icon: "bx-cog",
    badge: {
      variant: "info",
      text: "menuitems.setting.badge",
    },
    subItems: [
      {
        id: 1,
        label: "menuitems.setting.list.category",
        link: "/setting/category",
        parentId: 2,
      },
      {
        id: 2,
        label: "menuitems.setting.list.festival",
        link: "/setting/festival",
        parentId: 2,
      },
      {
        id: 3,
        label: "menuitems.setting.list.tag",
        link: "/setting/tag",
        parentId: 2,
      },
      {
        id: 4,
        label: "menuitems.setting.list.office",
        link: "/setting/office",
        parentId: 2,
      },
    ],
  },
  {
    id: 3,
    label: "menuitems.event.text",
    icon: "bx-list-ul",
    badge: {
      variant: "info",
      text: "",
    },
    subItems: [
      {
        id: 1,
        label: "menuitems.event.list.list",
        link: "/event/list",
        parentId: 3,
      },
      {
        id: 2,
        label: "menuitems.event.list.listEdit",
        link: "/event/list-edit",
        parentId: 3,
      },
      {
        id: 3,
        label: "menuitems.event.list.highlight",
        link: "/event/highlight",
        parentId: 3,
      },
    ],
  },
  {
    id: 4,
    label: "menuitems.tat.text",
    icon: "bxs-data",
    badge: {
      variant: "info",
      text: "",
    },
    subItems: [
      {
        id: 1,
        label: "menuitems.tat.list.list",
        link: "/tat/list",
        parentId: 4,
      },
      {
        id: 2,
        label: "menuitems.tat.list.listApt",
        link: "/tat/list-apt",
        parentId: 4,
      }
    ],
  },
  {
    id: 5,
    label: "menuitems.user.text",
    icon: "bx-user",
    link: "/user",
    roleAdmin: true,
  },
  {
    id: 6,
    label: "menuitems.report.text",
    icon: "bxs-file",
    link: "/report",
    roleAdmin: true,
  },
];
